import api from 'api'
import { WageJurisdiction } from './getJurisdictions'

export type WageCoverageScope = 'full' | 'unincorporated_only'

export type ActiveRule = {
  id: number
  effectiveStart: string
  effectiveEnd: string | null
  coverageScope: WageCoverageScope
}

export type WageJurisdictionDetail = WageJurisdiction & {
  rules: ActiveRule[]
}

export const getJurisdictionById = async (
  id: number
): Promise<WageJurisdictionDetail> => {
  const response = await api.get<WageJurisdictionDetail>(
    `/admin/wage/jurisdictions/${id}`
  )
  return response.data
}
